function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { textStyles, themeSpaces } from '../../../../theme/foundations';
var IndicatorSizes = {
  ActiveState: 12,
  DefaultState: 8
};
var indicatorContainerSize = 24; // Equals to the title's line height (body3Semi)

var indicatorContainerHalfSize = indicatorContainerSize / 2;
var connectorThickness = 2;
var connectorThicknessHalf = connectorThickness / 2;
var verticalPadding = themeSpaces.l;

var getIndicatorSize = isActive => isActive ? IndicatorSizes.ActiveState : IndicatorSizes.DefaultState;

var getVerticalConnectorStyle = isFirstStep => {
  if (isFirstStep) {
    return {
      height: "calc(100% + ".concat(verticalPadding, ")"),
      top: "".concat(indicatorContainerHalfSize, "px")
    };
  }

  return {
    height: '100%',
    top: "calc(".concat(indicatorContainerHalfSize, "px + ").concat(verticalPadding, ")")
  };
};

var horizontalStyles = {
  gridTemplateAreas: "\"indicator\"\n    \"title\"\n    \"description\"",
  gridTemplateRows: "".concat(textStyles.body3Semi.lineHeight.xs, " auto auto"),
  alignItems: 'center',
  gridRowGap: 'xxs'
};
var verticalStyles = {
  gridTemplateAreas: "\"indicator title\"\n  \". description\"",
  gridTemplateColumns: "".concat(textStyles.body3Semi.lineHeight.xs, " auto"),
  alignItems: 'flex-start',
  gridColumnGap: 'xs',
  gridRowGap: 'xxs'
};
export var trackerStepTheme = {
  baseStyle: _ref => {
    var {
      isActive,
      isDone,
      isComplete
    } = _ref;
    return {
      stepContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative'
      },
      grid: {
        display: 'grid'
      },
      connector: {
        position: 'absolute',
        backgroundColor: isDone || isComplete ? 'success.main' : 'neutral.lighter'
      },
      stepIndicatorContainer: {
        gridArea: 'indicator',
        justifySelf: 'center',
        alignSelf: 'center',
        zIndex: 1
      },
      stepIndicator: {
        width: "".concat(getIndicatorSize(!!isActive), "px"),
        height: "".concat(getIndicatorSize(!!isActive), "px"),
        borderRadius: 'full',
        backgroundColor: isDone || isActive || isComplete ? 'success.main' : 'neutral.light'
      },
      title: {
        gridArea: 'title',
        display: 'flex',
        justifyContent: 'center'
      },
      description: {
        gridArea: 'description',
        display: 'flex',
        justifyContent: 'center'
      }
    };
  },
  variants: {
    horizontal: _ref2 => {
      var {
        isActive
      } = _ref2;
      return {
        stepContainer: {
          alignItems: 'center'
        },
        grid: horizontalStyles,
        connector: _objectSpread({
          height: "".concat(connectorThickness, "px"),
          top: "calc(".concat(indicatorContainerHalfSize, "px - ").concat(connectorThicknessHalf, "px)"),
          width: '100%',
          left: '50%'
        }, isActive && {
          bgGradient: 'linear(to right, success.main, neutral.lighter 66%)'
        })
      };
    },
    vertical: _ref3 => {
      var {
        isFirstStep,
        isLastStep,
        isActive
      } = _ref3;
      return {
        stepContainer: {
          alignItems: 'flex-start',
          paddingTop: isFirstStep ? 'none' : 'l',
          paddingBottom: isLastStep ? 'none' : 'l'
        },
        grid: verticalStyles,
        connector: _objectSpread(_objectSpread({}, getVerticalConnectorStyle(!!isFirstStep)), {}, {
          width: "".concat(connectorThickness, "px"),
          left: "calc(".concat(indicatorContainerHalfSize, "px - ").concat(connectorThicknessHalf, "px)")
        }, isActive && {
          bgGradient: 'linear(to bottom, success.main, neutral.lighter 66%)'
        }),
        title: {
          justifySelf: 'flex-start'
        },
        description: {
          justifySelf: 'flex-start'
        }
      };
    }
  }
};
//# sourceMappingURL=TrackerStep.theme.js.map